import { Injectable } from '@angular/core';
import {
ActivatedRouteSnapshot,
Router,
RouterStateSnapshot,
} from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { CommunityAuthService } from 'app/services/community-auth.service';
import { OAuthConfig } from 'environments/environment';
import { from,Observable,of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class AuthGuard {
  constructor(
    private oauthService: OAuthService,
    private authService: CommunityAuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    this.oauthService.configure(OAuthConfig);
    return from(this.oauthService.tryLoginCodeFlow())
        .pipe(switchMap(f => of(this.oauthService.hasValidAccessToken())));
  }
}
